import { render, staticRenderFns } from "./case-storage.vue?vue&type=template&id=57a485a7&scoped=true&"
import script from "./case-storage.vue?vue&type=script&lang=js&"
export * from "./case-storage.vue?vue&type=script&lang=js&"
import style0 from "./case-storage.scss?vue&type=style&index=0&id=57a485a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a485a7",
  null
  
)

export default component.exports